import { create } from "zustand"

interface HomeUIStore {
  selectedTreatmentTab: number
  setSelectedTreatmentTab: (selectedTreatmentTab: number) => void
}

const useHomeUIStore = create<HomeUIStore>((set) => ({
  selectedTreatmentTab: 0,
  setSelectedTreatmentTab: (selectedTreatmentTab: number) => set({ selectedTreatmentTab }),
}))

export default useHomeUIStore
